<template>
  <div class="kf-page">
    <div class="kf-container">

      <div class="kf-header">
        <div class="d-flex align-items-center">
          <button class="kf-back" @click="$router.push('/xisobot/main')" type="button">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <div>
            <h2 class="kf-title">
              <b-icon icon="wallet-fill" class="mr-2"></b-icon>
              {{ $t("Kassa Kirim/Chiqim") }}
            </h2>
            <div class="kf-subtitle">Barcha kassa harakati (savdo, kassa order va h.k.) bo'yicha</div>
          </div>
        </div>
        <div class="kf-actions">
          <button class="kf-btn kf-btn-secondary" @click="exportCsv" :disabled="loading">
            <b-icon icon="file-earmark-excel"></b-icon> Excel
          </button>
        </div>
      </div>

      <!-- FILTRLAR -->
      <div class="kf-filters">
        <div class="kf-filter">
          <label>Boshlanish</label>
          <input type="date" v-model="date1" @change="fetch">
        </div>
        <div class="kf-filter">
          <label>Tugash</label>
          <input type="date" v-model="date2" @change="fetch">
        </div>
        <div class="kf-filter kf-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="kf-filter">
          <label>&nbsp;</label>
          <button class="kf-btn kf-btn-primary" @click="fetch" :disabled="loading">
            <b-icon icon="arrow-repeat"></b-icon> Yangilash
          </button>
        </div>
      </div>

      <!-- SUMMARY (so'm) -->
      <div class="kf-summary">
        <div class="kf-card kf-1">
          <div class="kf-card-label">BOSHLANG'ICH BALANS</div>
          <div class="kf-card-value">{{ fmt(totals.begin_balance) }}</div>
        </div>
        <div class="kf-card kf-2">
          <div class="kf-card-label">KIRIM</div>
          <div class="kf-card-value kf-green">+ {{ fmt(totals.kirim) }}</div>
        </div>
        <div class="kf-card kf-3">
          <div class="kf-card-label">CHIQIM</div>
          <div class="kf-card-value kf-red">- {{ fmt(totals.chiqim) }}</div>
        </div>
        <div class="kf-card kf-4">
          <div class="kf-card-label">SOF HARAKAT</div>
          <div class="kf-card-value" :class="netClass">{{ totals.kirim - totals.chiqim >= 0 ? '+ ' : '- ' }}{{ fmt(Math.abs(totals.kirim - totals.chiqim)) }}</div>
        </div>
        <div class="kf-card kf-5">
          <div class="kf-card-label">YAKUNIY BALANS</div>
          <div class="kf-card-value kf-strong">{{ fmt(totals.end_balance) }}</div>
        </div>
      </div>

      <!-- SUMMARY (dollar) — dollar kassa alohida yuritiladi, so'mga qo'shilmaydi -->
      <div class="kf-summary kf-summary-dollar" v-if="hasDollar">
        <div class="kf-card kf-1">
          <div class="kf-card-label">BOSHLANG'ICH $ BALANS</div>
          <div class="kf-card-value">$ {{ fmt(totals.begin_balance_dollar) }}</div>
        </div>
        <div class="kf-card kf-2">
          <div class="kf-card-label">$ KIRIM</div>
          <div class="kf-card-value kf-green">+ $ {{ fmt(totals.kirim_dollar) }}</div>
        </div>
        <div class="kf-card kf-3">
          <div class="kf-card-label">$ CHIQIM</div>
          <div class="kf-card-value kf-red">- $ {{ fmt(totals.chiqim_dollar) }}</div>
        </div>
        <div class="kf-card kf-4">
          <div class="kf-card-label">$ SOF HARAKAT</div>
          <div class="kf-card-value" :class="netDollarClass">
            {{ totals.kirim_dollar - totals.chiqim_dollar >= 0 ? '+ ' : '- ' }}$ {{ fmt(Math.abs(totals.kirim_dollar - totals.chiqim_dollar)) }}
          </div>
        </div>
        <div class="kf-card kf-5">
          <div class="kf-card-label">YAKUNIY $ BALANS</div>
          <div class="kf-card-value kf-strong">$ {{ fmt(totals.end_balance_dollar) }}</div>
        </div>
      </div>

      <!-- CHART -->
      <div class="kf-chart-wrap" v-if="daily.length > 0">
        <h3 class="kf-block-title">Kunlik harakat</h3>
        <apexchart type="area" height="280" :options="chartOptions" :series="chartSeries"></apexchart>
      </div>

      <!-- TO'LOV TURLARI -->
      <div class="kf-section">
        <h3 class="kf-block-title">To'lov turlari kesimida</h3>
        <div class="kf-table-wrap">
          <table class="kf-table">
            <thead>
              <tr>
                <th>To'lov turi</th>
                <th class="t-right">Boshlang'ich</th>
                <th class="t-right">Kirim</th>
                <th class="t-right">Chiqim</th>
                <th class="t-right">Yakuniy</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in byPayType" :key="r.pay_type_id">
                <td class="kf-strong">{{ r.pay_type_name }} <span v-if="r.pay_type_id === 3" class="kf-badge-dollar">$</span></td>
                <td class="t-right">{{ fmt(r.begin_balance) }}</td>
                <td class="t-right kf-green">{{ fmt(r.kirim) }}</td>
                <td class="t-right kf-red">{{ fmt(r.chiqim) }}</td>
                <td class="t-right kf-strong">{{ fmt(r.end_balance) }}</td>
              </tr>
              <tr v-if="byPayType.length === 0">
                <td colspan="5" class="kf-empty">Ma'lumot yo'q</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ASOSLAR KESIMIDA -->
      <div class="kf-section kf-reason-section">
        <div class="kf-reason-header">
          <div class="kf-reason-title-wrap">
            <div class="kf-reason-icon"><b-icon icon="diagram-3-fill"></b-icon></div>
            <div>
              <div class="kf-reason-title">Asoslar kesimida</div>
              <div class="kf-reason-subtitle">Asoslar bo'yicha kirim-chiqim hisoboti</div>
            </div>
          </div>
          <div class="kf-reason-stats">
            <div class="kf-reason-stat">
              <div class="kf-reason-stat-icon green"><b-icon icon="cash-stack"></b-icon></div>
              <div>
                <div class="kf-reason-stat-label">Jami kirim</div>
                <div class="kf-reason-stat-value">{{ fmt(totals.kirim) }}<span class="kf-reason-stat-unit">so'm</span></div>
              </div>
            </div>
            <div class="kf-reason-stat">
              <div class="kf-reason-stat-icon red"><b-icon icon="arrow-up-circle-fill"></b-icon></div>
              <div>
                <div class="kf-reason-stat-label">Jami chiqim</div>
                <div class="kf-reason-stat-value">{{ fmt(totals.chiqim) }}<span class="kf-reason-stat-unit">so'm</span></div>
              </div>
            </div>
            <div class="kf-reason-stat">
              <div class="kf-reason-stat-icon blue"><b-icon icon="cash-coin"></b-icon></div>
              <div>
                <div class="kf-reason-stat-label">Jami kirim (USD)</div>
                <div class="kf-reason-stat-value">{{ fmt(totals.kirim_dollar) }}<span class="kf-reason-stat-unit">$</span></div>
              </div>
            </div>
            <div class="kf-reason-stat">
              <div class="kf-reason-stat-icon orange"><b-icon icon="box-arrow-up"></b-icon></div>
              <div>
                <div class="kf-reason-stat-label">Jami chiqim (USD)</div>
                <div class="kf-reason-stat-value">{{ fmt(totals.chiqim_dollar) }}<span class="kf-reason-stat-unit">$</span></div>
              </div>
            </div>
          </div>
        </div>

        <div class="kf-table-wrap">
          <table class="kf-table kf-reason-table">
            <thead>
              <tr>
                <th class="t-center">#</th>
                <th><b-icon icon="person-fill" class="mr-1"></b-icon>Asos</th>
                <th class="t-center">Hujjat soni</th>
                <th class="t-right"><b-icon icon="arrow-down-circle-fill" class="kf-arrow green"></b-icon>Kirim, so'm</th>
                <th class="t-right"><b-icon icon="arrow-up-circle-fill" class="kf-arrow red"></b-icon>Chiqim, so'm</th>
                <th class="t-right"><b-icon icon="arrow-down-circle-fill" class="kf-arrow green"></b-icon>Kirim, $</th>
                <th class="t-right"><b-icon icon="arrow-up-circle-fill" class="kf-arrow red"></b-icon>Chiqim, $</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in byReason" :key="i">
                <td class="t-center"><span class="kf-row-num">{{ i + 1 }}</span></td>
                <td class="kf-strong">{{ r.reason || '—' }}</td>
                <td class="t-center"><span class="kf-badge">{{ r.doc_count }}</span></td>
                <td class="t-right kf-green">{{ fmt(r.kirim) }}</td>
                <td class="t-right kf-red">{{ fmt(r.chiqim) }}</td>
                <td class="t-right kf-green">{{ fmt(r.kirim_dollar) }}</td>
                <td class="t-right kf-red">{{ fmt(r.chiqim_dollar) }}</td>
              </tr>
              <tr v-if="byReason.length === 0">
                <td colspan="7" class="kf-empty">Ma'lumot yo'q</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'KassaFlowReport',
  data() {
    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.dateStr(first),
      date2: this.dateStr(today),
      sklad_id: null,
      skladList: [],
      byPayType: [],
      byReason: [],
      daily: [],
      totals: this.emptyTotals(),
      loading: false,
    };
  },
  computed: {
    netClass() {
      const v = (this.totals.kirim || 0) - (this.totals.chiqim || 0);
      return v >= 0 ? 'kf-green' : 'kf-red';
    },
    netDollarClass() {
      const v = (this.totals.kirim_dollar || 0) - (this.totals.chiqim_dollar || 0);
      return v >= 0 ? 'kf-green' : 'kf-red';
    },
    // Dollar kartochkalarini faqat dollar harakati bo'lganda ko'rsatamiz
    hasDollar() {
      const t = this.totals || {};
      return !!(parseFloat(t.kirim_dollar) || parseFloat(t.chiqim_dollar)
        || parseFloat(t.begin_balance_dollar) || parseFloat(t.end_balance_dollar));
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false }, fontFamily: 'inherit' },
        colors: ['#16a34a', '#e11d48'],
        stroke: { curve: 'smooth', width: 2 },
        markers: { size: 4, strokeWidth: 2, hover: { size: 6 } },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.05 } },
        xaxis: { categories: this.daily.map(d => d.day), labels: { style: { fontSize: '11px' } } },
        yaxis: { labels: { formatter: v => this.fmt(v) } },
        dataLabels: { enabled: false },
        legend: { position: 'top' },
        grid: { borderColor: '#f1f5f9' },
        tooltip: { y: { formatter: v => this.fmt(v) + " so'm" } }
      };
    },
    chartSeries() {
      return [
        { name: 'Kirim', data: this.daily.map(d => parseFloat(d.kirim) || 0) },
        { name: 'Chiqim', data: this.daily.map(d => parseFloat(d.chiqim) || 0) },
      ];
    }
  },
  mounted() {
    this.loadSklads();
    this.fetch();
  },
  methods: {
    dateStr(d) {
      if (!d) return '';
      const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    emptyTotals() {
      return {
        kirim: 0, chiqim: 0, begin_balance: 0, end_balance: 0,
        kirim_dollar: 0, chiqim_dollar: 0, begin_balance_dollar: 0, end_balance_dollar: 0,
      };
    },
    toUnix(s, end = false) {
      if (!s) return 0;
      const d = new Date(s + (end ? 'T23:59:59' : 'T00:00:00'));
      return Math.floor(d.getTime() / 1000);
    },
    fmt(v) {
      const n = parseFloat(v) || 0;
      return n.toLocaleString('ru-RU', { maximumFractionDigits: 2 });
    },
    // Tanlangan davrdagi barcha kunlarni chiqaramiz — ma'lumot yo'q kunlar 0 bilan to'ldiriladi,
    // aks holda bitta kunlik davrda grafik vertikal chiziq bo'lib qoladi
    fillDays(daily) {
      if (!this.date1 || !this.date2) return daily;
      const map = {};
      (daily || []).forEach(r => { map[r.day] = r; });
      const out = [];
      const d = new Date(this.date1 + 'T00:00:00');
      const end = new Date(this.date2 + 'T00:00:00');
      while (d <= end) {
        const key = this.dateStr(d);
        out.push(map[key] || { day: key, kirim: 0, chiqim: 0 });
        d.setDate(d.getDate() + 1);
      }
      return out;
    },
    async loadSklads() {
      try { const res = await axios.get('api/v1/sklads'); this.skladList = res.data || []; } catch (e) { this.skladList = []; }
    },
    async fetch() {
      this.loading = true;
      try {
        const res = await axios.post('api/v1/report/kassa-flow/', {
          datetime1: this.toUnix(this.date1, false),
          datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        const d = res.data || {};
        this.byPayType = d.by_pay_type || [];
        this.byReason = d.by_reason || [];
        this.daily = this.fillDays(d.daily || []);
        this.totals = Object.assign(this.emptyTotals(), d.totals || {});
      } catch (e) {
        console.error('Kassa flow err:', e);
      } finally { this.loading = false; }
    },
    exportCsv() {
      const rows = [
        ["To'lov turi", "Boshlang'ich", 'Kirim', 'Chiqim', 'Yakuniy'],
        ...this.byPayType.map(r => [r.pay_type_name, r.begin_balance, r.kirim, r.chiqim, r.end_balance]),
        [],
        ['Asos', 'Hujjat soni', "Kirim, so'm", "Chiqim, so'm", 'Kirim, $', 'Chiqim, $'],
        ...this.byReason.map(r => [r.reason, r.doc_count, r.kirim, r.chiqim, r.kirim_dollar, r.chiqim_dollar]),
      ];
      const csv = rows.map(r => r.map(c => `"${String(c === undefined ? '' : c).replace(/"/g, '""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿" + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `kassa_flow_${this.date1}_${this.date2}.csv`; a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.kf-page { padding: 20px; background: #f4f7f9; height: calc(100vh - 56px); overflow-y: auto; }
.kf-container { max-width: 1400px; margin: 0 auto; }
.kf-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 18px; }
.kf-back { width: 40px; height: 40px; border-radius: 50%; border: 1px solid #e0e6ed; background: white; color: #7f8c8d; display: flex; align-items: center; justify-content: center; cursor: pointer; margin-right: 12px; }
.kf-title { font-weight: 800; font-size: 22px; color: #0f172a; margin: 0; display: flex; align-items: center; }
.kf-subtitle { font-size: 12px; color: #94a3b8; font-weight: 600; margin-top: 2px; }
.kf-summary-dollar .kf-card-label { color: #10b981; }
.kf-actions { display: flex; gap: 10px; }
.kf-btn { border: none; padding: 9px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; }
.kf-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.kf-btn-primary { background: #a142f4; color: white; }
.kf-btn-secondary { background: white; color: #475569; border: 1px solid #cbd5e1; }

.kf-filters { display: flex; gap: 12px; background: white; padding: 14px; border-radius: 14px; margin-bottom: 16px; border: 1px solid #f1f5f9; align-items: flex-end; }
.kf-filter { display: flex; flex-direction: column; min-width: 140px; }
.kf-filter-grow { flex: 1; min-width: 200px; }
.kf-filter label { font-size: 10px; color: #94a3b8; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.kf-filter input { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 9px 12px; font-weight: 600; outline: none; }

.kf-summary { display: grid; grid-template-columns: repeat(5, 1fr); gap: 12px; margin-bottom: 18px; }
.kf-card { background: white; border-radius: 14px; padding: 14px 16px; border: 1px solid #f1f5f9; border-top: 3px solid; }
.kf-1 { border-top-color: #6366f1; }
.kf-2 { border-top-color: #16a34a; }
.kf-3 { border-top-color: #e11d48; }
.kf-4 { border-top-color: #a142f4; }
.kf-5 { border-top-color: #0891b2; }
.kf-card-label { font-size: 10px; color: #94a3b8; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.kf-card-value { font-size: 18px; font-weight: 800; color: #0f172a; }

.kf-chart-wrap, .kf-section { background: white; border-radius: 14px; padding: 16px; border: 1px solid #f1f5f9; margin-bottom: 16px; }
.kf-block-title { font-weight: 800; font-size: 14px; color: #0f172a; margin: 0 0 12px 0; }

.kf-table-wrap { overflow-x: auto; }
.kf-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.kf-table th { background: #f8fafc; padding: 10px; text-align: left; font-size: 11px; color: #64748b; font-weight: 800; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; }
.kf-table td { padding: 11px 10px; border-bottom: 1px solid #f1f5f9; }
.kf-table tbody tr:hover { background: #faf8ff; }

.t-center { text-align: center; }
.t-right { text-align: right; font-variant-numeric: tabular-nums; }
.kf-strong { font-weight: 700; color: #0f172a; }
.kf-green { color: #16a34a; font-weight: 700; }
.kf-red { color: #e11d48; font-weight: 700; }
.kf-empty { text-align: center; color: #94a3b8; padding: 30px; font-style: italic; }
.kf-badge { background: #dbeafe; color: #2563eb; padding: 2px 10px; border-radius: 999px; font-size: 11px; font-weight: 700; }
.kf-badge-dollar { background: #10b981; color: white; font-size: 10px; padding: 1px 6px; border-radius: 6px; margin-left: 6px; }

/* Asoslar kesimida — alohida bo'lim sarlavhasi + 4 ta statistik kartochka */
.kf-reason-section { padding: 16px; }
.kf-reason-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 16px; }
.kf-reason-title-wrap { display: flex; align-items: center; gap: 12px; }
.kf-reason-icon {
  width: 46px; height: 46px; border-radius: 14px; flex-shrink: 0;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white; display: flex; align-items: center; justify-content: center; font-size: 20px;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.3);
}
.kf-reason-title { font-weight: 800; font-size: 16px; color: #0f172a; }
.kf-reason-subtitle { font-size: 12px; color: #94a3b8; font-weight: 600; margin-top: 2px; }

.kf-reason-stats { display: flex; gap: 10px; flex-wrap: wrap; }
.kf-reason-stat {
  display: flex; align-items: center; gap: 10px;
  background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 14px; padding: 8px 14px;
}
.kf-reason-stat-icon {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 16px; color: white;
}
.kf-reason-stat-icon.green { background: #16a34a; }
.kf-reason-stat-icon.red { background: #f43f5e; }
.kf-reason-stat-icon.blue { background: #2563eb; }
.kf-reason-stat-icon.orange { background: #f97316; }
.kf-reason-stat-label { font-size: 11px; color: #94a3b8; font-weight: 700; }
.kf-reason-stat-value { font-size: 15px; font-weight: 800; color: #0f172a; white-space: nowrap; }
.kf-reason-stat-unit { font-size: 11px; color: #94a3b8; font-weight: 700; margin-left: 4px; }

.kf-reason-table th { white-space: nowrap; }
.kf-arrow { margin-right: 4px; }
.kf-arrow.green { color: #16a34a; }
.kf-arrow.red { color: #e11d48; }
.kf-row-num {
  display: inline-flex; align-items: center; justify-content: center;
  width: 24px; height: 24px; border-radius: 50%;
  background: #eef2ff; color: #4f46e5; font-size: 11px; font-weight: 800;
}
.kf-reason-table tbody tr:hover { background: #eff6ff; }

@media (max-width: 991px) {
  .kf-summary { grid-template-columns: repeat(2, 1fr); }
  .kf-reason-header { flex-direction: column; align-items: flex-start; }
  .kf-reason-stats { width: 100%; }
}
</style>
